export default __webpack_public_path__ + "static/media/gallery-wip-emitter-tip_01.3365437d.jpg";